import { defineFieldDisplay } from "../defines";
import FormattedValue from "./formatted-value.vue";

export default defineFieldDisplay({
  id: "formatted-value",
  component: FormattedValue,
});
